import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { MpanResult, MprnResult } from "@/api/backofficeRest/generated/model"
import { MPANAddress, MPRNAddress, MPXNAddress } from "./meterpointAddress"
import { IMPANAddress, IMPRNAddress } from "./meterpointAddress.types"

// formatAddress skips undefined and "" but not null, which it would render as
// the word "null". The gateway sends MPAN address10 as null when it's absent.
const addressLine = (line?: string | null) => line ?? undefined

export const MPANAddressParser: IParser<IMPANAddress, MpanResult> = {
  toDomain: (data: MpanResult) => {
    try {
      return new MPANAddress(
        new MPXNAddress(
          data.postcode ?? "",
          addressLine(data.address1),
          addressLine(data.address2),
          addressLine(data.address3),
          addressLine(data.address4),
          addressLine(data.address5),
          addressLine(data.address6),
          addressLine(data.address7),
          addressLine(data.address8),
          addressLine(data.address9),
          addressLine(data.address10),
        ),
        data.mpan ?? "",
        data.profileClassId ?? null,
        data.meterTimeswitchCode ?? null,
        data.lineLossFactorClassId ?? "",
        data.gspGroupId ?? "",
        data.standardSettlementConfigurationId ?? "",
        data.meterTypeId ?? "",
        data.meterSerialNumber ?? "",
        data.measurementClass ?? "",
        data.energised ?? false,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const MPRNAddressParser: IParser<IMPRNAddress, MprnResult> = {
  toDomain: (data: MprnResult) => {
    try {
      return new MPRNAddress(
        new MPXNAddress(
          data.postcode ?? "",
          addressLine(data.address1),
          addressLine(data.address2),
          addressLine(data.address3),
          addressLine(data.address4),
          addressLine(data.address5),
          addressLine(data.address6),
          addressLine(data.address7),
          addressLine(data.address8),
          addressLine(data.address9),
          addressLine(data.address10),
        ),
        data.mprn ?? "",
        data.designation ?? "",
        data.meterSerialNumber ?? "",
        data.prepayDetected ?? false,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
